export { default } from './InputDecimal'